import { getMicrosoftOAuthURL } from '../api/api';

export const loginWithMicrosoft = async () => {
  const response = await getMicrosoftOAuthURL();
  const url = response?.data?.data?.connectionURL;
  window.location.href = url;
};
